function planSamplingSelectDirective() {
	return {
		scope : {
			idClient : '=?',
			planSampling : '=?',
			onPlanSamplingChange : '&',
			requiredModel : '@?required',
			requireClient : '@?',
			disabled : '&',
			multiple : '@?',
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/planSamplingSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'planSamplingService', function($scope, $window, alertService, planSamplingService) {

			var init = true;
			var requireClient = false;
			$scope.ctrlDisabled = false;

			$scope.valueWasChangedFromSelector = false;
			$scope.availablePlanSampling = [];
			$scope.required = false;
			$scope.limit = 1;
			
			if(angular.isDefined($scope.multiple))
				$scope.limit = undefined;

			if ($scope.requiredModel)
				$scope.required = true;
			
			if ($scope.disabled())
				$scope.ctrlDisabled = true;
			
			//si se define la propiedad, se toma como verdadero
			if (!angular.isUndefined($scope.requireClient))
				requireClient = true;

			$scope.searchPlanSampling = function(query) {
				if ($scope.sitesCount && $scope.sitesLimit) {
					if ($scope.planSamplingCount <= $scope.planSamplingLimit)
						return;
				}
				var filter = {};

				if (query) {
					filter.name = query;
				}

				//si no hay cliente y es requerido, no se hace la solicitud
				if(angular.isUndefined($scope.idClient) && requireClient){
					$scope.availablePlanSampling = [];
					return;
				}
				
				if ($scope.idClient) {
					filter.idClient = $scope.idClient;
				}

				planSamplingService.searchPlanSamplingBasicInfo(filter).then(function(response) {
					var resp = response.getData();
					$scope.availablePlanSampling = resp.results;
					if (!$scope.planSamplingCount)
						$scope.planSamplingCount = resp.totalRegisters;
					$scope.planSamplingLimit = resp.limit;

					/*
					 * se hace solo la primera vez y es por si solo se conoce el
					 * id del plan de muestreo que se quiere seleccionar
					 */
					if ($scope.planSampling && $scope.planSampling.id && init) {
						init = false;
						var sel = $scope.availablePlanSampling.find(function(p) {
							return p.id == $scope.planSampling.id;
						});
						if (sel) {
							$scope.planSampling.selected = [];
							$scope.planSampling.selected.push(sel);
						} else {
							planSamplingService.getPlanSamplingBasicInfo($scope.planSampling.id).then(function(response) {
								$scope.planSampling.selected = [];
								$scope.planSampling.selected.push(response.getData());
							});
						}
						$scope.planSampling.id = undefined;
					}

				}, function(response) {
					// on error
				});
			};

			$scope.planSamplingChanged = function(planSampling) {
				$scope.valueWasChangedFromSelector = true;
				if ($scope.onPlanSamplingChange != undefined) {
					$scope.onPlanSamplingChange({
						planSamplingSelected : planSampling
					});
				}
			};

			$scope.$watch('idClient', function(newValue, oldValue) {
				$scope.planSamplingCount = undefined;
				$scope.planSamplingLimit = undefined;
				$scope.searchPlanSampling();
			});

		} ],
		link : function(scope, elem, attr) {
			scope.$watch("disabled()", function(newValue){
				scope.ctrlDisabled = newValue;
			});
		}
	};
};

module.directive('planSamplingSelect', [ planSamplingSelectDirective ]);
